<template>
  <unicom-cartao
    :marginBody="false"
    :estilo="{ 'margin-top': '16px' }"
    style="padding: 5rem 10vw"
  >
    <template #header>
      <h1 class="titulo">Análise Produtividade</h1>
    </template>
    <template #body>
      <div class="container">
        <unicom-linha class="input-wrapper">
          <unicom-coluna sm="6" class="input_control">
            <unicom-campo-calendario
              fecharClique
              placeHolder="Data Inicial"
              class="invalid"
              v-model="dataInicial"
            />
          </unicom-coluna>
          <unicom-coluna sm="6" class="input_control">
            <unicom-campo-calendario
              fecharClique
              placeHolder="Data Final"
              v-model="dataFinal"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="input_control">
            <multi-select
              v-model="analistasSelecionados"
              :propsMultiselect="{
                placeholder: 'Analista Responsável',
                options: comboAnalistas,
                'track-by': 'id',
                label: 'nome'
              }"
            ></multi-select>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </template>
    <template #footer>
      <div class="container">
        <unicom-botao @click="download">CONTINUAR</unicom-botao>
      </div>
    </template>
  </unicom-cartao>
</template>

<script>
import MultiSelect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";

import AnaliseProdMixin from "./mixins/AnaliseProdMixin";

export default {
  components: {
    MultiSelect
  },
  mixins: [AnaliseProdMixin],
  data() {
    return {};
  }
};
</script>

<style scoped>
.titulo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem auto;
}
.input-wrapper {
  display: flex;
}
.input_control {
  margin: 1rem 0;
}
/* .invalid {
  border: red 1px solid;
  border-radius: 7px;
} */
</style>
